import DragIndicator from '@material-ui/icons/DragIndicator';

import { ForwardedRef, forwardRef, ReactElement } from 'react';

import './drag-handle.styles.scss';

function DragHandleView(
	_: object,
	ref: ForwardedRef<HTMLDivElement>
): ReactElement {
	return (
		<div className="drag-handle cursor-pointer" ref={ref}>
			<DragIndicator className="drag-handle-icon" />
		</div>
	);
}

export const DragHandle = forwardRef<HTMLDivElement, object>(DragHandleView);
